import { render, staticRenderFns } from "./SignupCompanyForm.vue?vue&type=template&id=2dd841ef&scoped=true&"
import script from "./SignupCompanyForm.vue?vue&type=script&lang=js&"
export * from "./SignupCompanyForm.vue?vue&type=script&lang=js&"
import style0 from "./SignupCompanyForm.vue?vue&type=style&index=0&id=2dd841ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd841ef",
  null
  
)

export default component.exports